import { Alert } from 'antd'

export const NotFound: React.FC = () => {
  return <Alert type="warning" description="File not found." showIcon />
}
